import BaseChart from './BaseChart'
import ItemsHelper from '../chart_helpers/ItemsHelper'
import RootHelper from '../chart_helpers/RootHelper'
import AxisHelper from '../chart_helpers/AxisHelper'
import SizeHelper from '../chart_helpers/SizeHelper'
import { categoricalExtent, continuousExtent } from '../chart_helpers/AxisHelper'
import SelectableHelper from '../chart_helpers/SelectableHelper'
import { getConnectionLines } from '../viz_behaviors/ConnectedDotPlotDataController'

export default class ConnectedDotPlot extends BaseChart {
  constructor(...args) {
    super(...args)
    this.zeroBased = false
  }
  static defaultConfig = {
    showDatumValues: {
      type: Boolean,
      default: false,
      exposed: true,
    },
    xAttr: {
      type: String,
      default: 'value',
      exposed: false,
    },
    yAttr: {
      type: String,
      default: 'id',
      exposed: false,
    },
    AxisHelper: {
      /**
       * Enable automatic scroll. If enabled, axes will be scrolalbel only if the number of bars is large enough.
       */
      zoom: {
        value: false,
        exposed: false,
        nonEditable: true,
      },
      y: {
        scale: {
          value: 'point',
          exposed: false,
          nonEditable: true,
        },
        showTickValues: {
          value: true,
          exposed: false,
          nonEditable: true,
        },
        tickOrientation: {
          exposed: false,
          nonEditable: true,
        },
        grid: true,
        unit: {
          exposed: false,
          nonEditable: true,
        },
        trimThreshold: {
          value: false,
          exposed: false,
          nonEditable: true,
        },
        tickWrap: {
          exposed: true,
          nonEditable: false,
        },
        getExtent: function (data) {
          let extent = categoricalExtent(data, d => d.id)
          // not sure (si todos son Dates, los ordenamos)
          if (extent.map(d => new Date(d)).every(d => !isNaN(d))) {
            extent = extent.toSorted((a, b) => new Date(a) - new Date(b))
          }
          return extent
        },
        valueFormat: d => d,
      },
      x: {
        showTickValues: {
          value: true,
          exposed: false,
          nonEditable: true,
        },
        scale: {
          value: 'linear',
          exposed: false,
          nonEditable: true,
        },
        tickOrientation: {
          exposed: true,
          nonEditable: false,
        },
        trimThreshold: {
          value: false,
          exposed: false,
          nonEditable: true,
        },
        grid: false,
        getExtent: function (data) {
          const extent = continuousExtent(data, d => d[this.config.xAttr])
          return extent
        },
      },
    },
    TooltipBehavior: {
      getItemOffset: function ($el) {
        let original = $el.getBoundingClientRect()
        return {
          x: original.x + original.width / 2,
          y: original.top, //- 5,
        }
      },
      getHtml: function (d) {
        return `
          <div class="tip-value important">${this.valueWithUnit(d.value, 'y')}</div>
          <div class="tip-id">
            <span class="icon" style="display: inline-block; width: 9px; height: 9px; border-radius: 50%; background: ${this.color(
              { id: d.parentId }
            )}; margin-right: 3px"></span>
            ${d.parentId}
          </div>
          <div class="secondary">${this.formatValue(d.id, 'x')}</div>
            `
      },
    },
  }
  static helpers = [RootHelper, ItemsHelper, SelectableHelper, SizeHelper, AxisHelper]
  checkConsistency() {
    return true
  }
  beforeHelpers() {
    this.margin = { top: 20, right: 100, left: 20, bottom: 20 }
  }

  getDuration() {
    return 400
  }
  draw() {
    //Draw lines between points
    const connectionLines = getConnectionLines(this.ghostData || this.data)

    let lines = this.content
      .selectAll('.connection-line')
      .data(Object.values(connectionLines), d => d.id)
    const linesEnter = lines.enter().append('line').attr('class', 'connection-line').lower()

    lines.exit().transition().duration(this.getDuration()).style('opacity', 0).remove()
    lines = lines.merge(linesEnter)
    lines
      .attr('stroke', d => '#E3E3E3')
      .attr('stroke-width', 2)
      .attr('x1', d => {
        return this.axes.x.func.scale()(d.xConnectStart)
      })
      .attr('x2', d => {
        return this.axes.x.func.scale()(d.xConnectStart)
      })
      .attr('y1', d => this.axes.y.func.scale()(d[this.config.yAttr]))
      .attr('y2', d => this.axes.y.func.scale()(d[this.config.yAttr]))
      .style('opacity', 1)
      .transition()
      .duration(this.getDuration())
      .delay(this.getDuration() / 2)
      .attr('x2', d => {
        return this.axes.x.func.scale()(d.xConnectEnd)
      })

    //Draw points
    this.itemsEnter
      .selectAll('.point')
      .data([null])
      .enter()
      .append('g')
      .attr('class', 'point')
      .append('circle')
    // this.itemsExit.remove()
    this.itemsEnter
      .select('.point')
      .raise()
      .select('circle')
      .attr('fill', d => this.color({ id: d.parentId }))
      .attr('r', 0)
      .attr('cx', d => {
        return this.axes.x.func.scale()(d[this.config.xAttr])
      })
      .attr('cy', d => this.axes.y.func.scale()(d[this.config.yAttr]))

    this.itemsEnterTrans.select('.point').select('circle').attr('r', '4px')

    this.itemsEnterTrans.select('.point').select('text').style('opacity', 0)
    this.itemsEnterTrans.select('.point').select('text').style('opacity', 1)
    this.itemsTrans
      .select('.point')
      .select('circle')
      .attr('fill', d => this.color({ id: d.parentId }))
      .attr('r', '4px')
      .attr('cx', d => {
        return this.axes.x.func.scale()(d[this.config.xAttr])
      })
      .attr('cy', d => this.axes.y.func.scale()(d[this.config.yAttr]))
    this.parentItemsExitTrans.style('opacity', 0)
  }
}
